import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
function SpinnerComponent_div_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, null, 3);
    i0.ɵɵelement(2, "span", 4)(3, "span", 4)(4, "span", 4);
    i0.ɵɵelementContainerEnd();
  }
}
function SpinnerComponent_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, null, 5);
    i0.ɵɵelement(2, "span", 6);
    i0.ɵɵelementContainerEnd();
  }
}
function SpinnerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, SpinnerComponent_div_0_ng_container_1_Template, 5, 0, "ng-container", 2)(2, SpinnerComponent_div_0_ng_container_2_Template, 3, 0, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.dark ? "sol-spinner-dark" : "sol-spinner-light");
    i0.ɵɵclassProp("bar", ctx_r0.variant === "bar")("circle", ctx_r0.variant === "circle");
    i0.ɵɵattribute("id", ctx_r0.id ? ctx_r0.id : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.variant === "bar");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.variant === "circle");
  }
}
class SpinnerComponent {
  constructor() {
    this.variant = 'bar';
    this.isSpinner = false;
    this.dark = false;
  }
  static {
    this.ɵfac = function SpinnerComponent_Factory(t) {
      return new (t || SpinnerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SpinnerComponent,
      selectors: [["sol-spinner"]],
      inputs: {
        variant: "variant",
        isSpinner: "isSpinner",
        dark: "dark",
        id: "id"
      },
      decls: 1,
      vars: 1,
      consts: [["role", "alert", "aria-live", "polite", "aria-busy", "true", 3, "class", "bar", "circle", 4, "ngIf"], ["role", "alert", "aria-live", "polite", "aria-busy", "true"], [4, "ngIf"], ["bar", ""], [1, "sol-spinner-bar"], ["circle", ""], [1, "sol-spinner-circle"]],
      template: function SpinnerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SpinnerComponent_div_0_Template, 3, 9, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.isSpinner);
        }
      },
      dependencies: [i1.NgIf],
      styles: [".sol-spinner-dark{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;align-items:center;height:1.5rem}.sol-spinner-dark span.sol-spinner-bar{height:1.25rem;width:.25rem;margin-right:.125rem;background-color:#fff;border-radius:.25rem;animation:bar-animation .6s linear infinite}.sol-spinner-dark span.sol-spinner-bar:nth-child(1){animation-delay:.1s}.sol-spinner-dark span.sol-spinner-bar:nth-child(2){animation-delay:.2s}.sol-spinner-dark span.sol-spinner-bar:nth-child(3){animation-delay:.3s}.sol-spinner-dark .sol-spinner-circle{width:1.5rem;height:1.5rem;display:inline-block;position:relative}.sol-spinner-dark .sol-spinner-circle:after,.sol-spinner-dark .sol-spinner-circle:before{content:\"\";box-sizing:border-box;width:1.5rem;height:1.5rem;border-radius:50%;position:absolute;left:0;top:0;animation:circle-animation 1s linear infinite;background:#fff}.sol-spinner-dark .sol-spinner-circle:after{opacity:0;animation-delay:.5s}.sol-spinner-light{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;align-items:center;height:1.5rem}.sol-spinner-light span.sol-spinner-bar{height:1.25rem;width:.25rem;margin-right:.125rem;background-color:var(--color-interface-blue550);border-radius:.25rem;animation:bar-animation .6s linear infinite}.sol-spinner-light span.sol-spinner-bar:nth-child(1){animation-delay:.1s}.sol-spinner-light span.sol-spinner-bar:nth-child(2){animation-delay:.2s}.sol-spinner-light span.sol-spinner-bar:nth-child(3){animation-delay:.3s}.sol-spinner-light .sol-spinner-circle{width:1.5rem;height:1.5rem;display:inline-block;position:relative}.sol-spinner-light .sol-spinner-circle:after,.sol-spinner-light .sol-spinner-circle:before{content:\"\";box-sizing:border-box;width:1.5rem;height:1.5rem;border-radius:50%;position:absolute;left:0;top:0;animation:circle-animation 1s linear infinite;background:var(--color-dataviz-color02-700)}.sol-spinner-light .sol-spinner-circle:after{opacity:0;animation-delay:.5s}@keyframes circle-animation{0%{transform:scale(0);opacity:1}to{transform:scale(1);opacity:0}}@keyframes bar-animation{0%{height:.125rem;opacity:.3}50%{height:1.25rem;opacity:1}to{height:.125rem;opacity:.3}}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerComponent, [{
    type: Component,
    args: [{
      selector: 'sol-spinner',
      template: `
    <div
      [class]="dark ? 'sol-spinner-dark' : 'sol-spinner-light'"
      [class.bar]="variant === 'bar'"
      [class.circle]="variant === 'circle'"
      [attr.id]="id ? id : null"
      *ngIf="isSpinner"
      role="alert"
      aria-live="polite"
      aria-busy="true"
    >
      <ng-container #bar *ngIf="variant === 'bar'">
        <span class="sol-spinner-bar"></span>
        <span class="sol-spinner-bar"></span>
        <span class="sol-spinner-bar"></span>
      </ng-container>
      <ng-container #circle *ngIf="variant === 'circle'">
        <span class="sol-spinner-circle"></span>
      </ng-container>
    </div>
  `,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: [".sol-spinner-dark{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;align-items:center;height:1.5rem}.sol-spinner-dark span.sol-spinner-bar{height:1.25rem;width:.25rem;margin-right:.125rem;background-color:#fff;border-radius:.25rem;animation:bar-animation .6s linear infinite}.sol-spinner-dark span.sol-spinner-bar:nth-child(1){animation-delay:.1s}.sol-spinner-dark span.sol-spinner-bar:nth-child(2){animation-delay:.2s}.sol-spinner-dark span.sol-spinner-bar:nth-child(3){animation-delay:.3s}.sol-spinner-dark .sol-spinner-circle{width:1.5rem;height:1.5rem;display:inline-block;position:relative}.sol-spinner-dark .sol-spinner-circle:after,.sol-spinner-dark .sol-spinner-circle:before{content:\"\";box-sizing:border-box;width:1.5rem;height:1.5rem;border-radius:50%;position:absolute;left:0;top:0;animation:circle-animation 1s linear infinite;background:#fff}.sol-spinner-dark .sol-spinner-circle:after{opacity:0;animation-delay:.5s}.sol-spinner-light{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;align-items:center;height:1.5rem}.sol-spinner-light span.sol-spinner-bar{height:1.25rem;width:.25rem;margin-right:.125rem;background-color:var(--color-interface-blue550);border-radius:.25rem;animation:bar-animation .6s linear infinite}.sol-spinner-light span.sol-spinner-bar:nth-child(1){animation-delay:.1s}.sol-spinner-light span.sol-spinner-bar:nth-child(2){animation-delay:.2s}.sol-spinner-light span.sol-spinner-bar:nth-child(3){animation-delay:.3s}.sol-spinner-light .sol-spinner-circle{width:1.5rem;height:1.5rem;display:inline-block;position:relative}.sol-spinner-light .sol-spinner-circle:after,.sol-spinner-light .sol-spinner-circle:before{content:\"\";box-sizing:border-box;width:1.5rem;height:1.5rem;border-radius:50%;position:absolute;left:0;top:0;animation:circle-animation 1s linear infinite;background:var(--color-dataviz-color02-700)}.sol-spinner-light .sol-spinner-circle:after{opacity:0;animation-delay:.5s}@keyframes circle-animation{0%{transform:scale(0);opacity:1}to{transform:scale(1);opacity:0}}@keyframes bar-animation{0%{height:.125rem;opacity:.3}50%{height:1.25rem;opacity:1}to{height:.125rem;opacity:.3}}\n"]
    }]
  }], null, {
    variant: [{
      type: Input
    }],
    isSpinner: [{
      type: Input
    }],
    dark: [{
      type: Input
    }],
    id: [{
      type: Input
    }]
  });
})();
class SpinnerModule {
  static {
    this.ɵfac = function SpinnerModule_Factory(t) {
      return new (t || SpinnerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SpinnerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerModule, [{
    type: NgModule,
    args: [{
      declarations: [SpinnerComponent],
      imports: [CommonModule],
      exports: [SpinnerComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { SpinnerComponent, SpinnerModule };
